import {
    CompanyProductSelectionPricingOptionWithOverrideInformation,
    ProductPricingOptionDTO
} from '@iota/iota-management-portal-v4-client';
import { deepCopy } from '../constants-and-enums/default-objects';

export interface PricingOptionDuplicateTarget {
    productId: string;
    companyId: string | null;
}

type PricingOptionSource = ProductPricingOptionDTO | CompanyProductSelectionPricingOptionWithOverrideInformation;

// Explicit allow-list, not an omit-list: ids are left out because an empty-string id would keep the copy out of edit mode.
export function duplicatePricingOption(source: PricingOptionSource, target: PricingOptionDuplicateTarget): ProductPricingOptionDTO {
    const copy: PricingOptionSource = deepCopy(source);

    return {
        productId: target.productId,
        companyId: target.companyId,
        locale: copy.locale,
        optionKey: copy.optionKey,
        optionName: copy.optionName,
        optionType: copy.optionType,
        optionDateValue: copy.optionDateValue,
        optionNumberValue: copy.optionNumberValue,
        optionTextValue: copy.optionTextValue,
        optionPricing: copy.optionPricing,
        optionCompanyPricing: copy.optionCompanyPricing,
        optionPricingPeriod: copy.optionPricingPeriod,
        optionPricingPercentage: copy.optionPricingPercentage,
        productOptionInternalNameKey: copy.productOptionInternalNameKey,
        productOptionCostsMonthly: copy.productOptionCostsMonthly,
        productOptionCostsYearly: copy.productOptionCostsYearly,
        productCostsSalesTax: copy.productCostsSalesTax,
        productCostsSalesTaxPassThrough: copy.productCostsSalesTaxPassThrough,
        isProductCostsSalesTaxPassThrough: copy.isProductCostsSalesTaxPassThrough,
        productCostsInsuranceTax: copy.productCostsInsuranceTax,
        externalPricingApproval: copy.externalPricingApproval,
        useProductPriceScale: copy.useProductPriceScale,
        recommended: copy.recommended,
        sortOrder: copy.sortOrder,
        effectiveFrom: copy.effectiveFrom,
        effectiveTo: copy.effectiveTo,
        reportingName: copy.reportingName,
        customerReportingName: copy.customerReportingName
    };
}
